import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Days",
    label: "Most Popular — Expedited Courier",
    tag: "Recommended",
    tagColor: "bg-[#F6C344]/30 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State courier",
      "Hand-carried submission — not mailed",
      "2–9 day turnaround for most applications",
      "Full document review before submission",
      "Real-time tracking throughout the process",
      "Not affected by government shutdowns",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Standard Expedited — Government Route",
    tag: "Good Value",
    tagColor: "bg-green-100 text-green-700",
    features: [
      "Government standard expedited processing",
      "3–5 week turnaround in optimal conditions",
      "Mail-in or acceptance facility submission",
      "Suitable for planned travel with buffer",
      "Affected by government shutdowns",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service — Post Office Route",
    tag: "Slowest",
    tagColor: "bg-red-100 text-red-700",
    features: [
      "Visit the Tupelo Post Office yourself",
      "No expedited processing — standard only",
      "Unpredictable 1–2 month timeline",
      "Errors cause complete restart of process",
      "No document review or guidance",
      "Affected by government shutdowns",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours",
    label: "Regional Agency Emergency",
    tag: "Life-or-Death Only",
    tagColor: "bg-gray-200 text-gray-600",
    features: [
      "For life-or-death emergencies only",
      "Requires proof of immediate travel",
      "Must appear at a Regional Passport Agency",
      "Nearest agency: ~3.5 hours to Atlanta",
      "No courier assistance — DIY only",
      "Unpredictable availability and wait times",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function TupeloProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing"
      cityName="Tupelo"
      headingExtra="Mississippi"
      introText="Whether you are a Toyota Motor Manufacturing team member heading to Japan for training, an ICC student with a study abroad acceptance, or a Northeast Mississippi family planning a Caribbean cruise — we have processing options that fit your timeline. As a registered U.S. Department of State courier, we offer processing radically faster than the post office."
      options={options}
      emergencyDescription="Only for documented life-or-death emergencies. Requires travel to the Atlanta Passport Agency ~3.5 hours east. No courier assistance. Unreliable availability."
      disclaimerText="Processing times are estimates based on current State Department workloads and are not guaranteed. Emergency/Rush service availability depends on documented travel need and application eligibility. Government fees not included in service pricing."
    />
  );
}